import { render, staticRenderFns } from "./_product.vue?vue&type=template&id=15796794&scoped=true&"
import script from "./_product.vue?vue&type=script&lang=js&"
export * from "./_product.vue?vue&type=script&lang=js&"
import style0 from "./_product.vue?vue&type=style&index=0&id=15796794&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15796794",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AirtableImage: require('/opt/build/repo/components/AirtableImage.vue').default,AppCarousel: require('/opt/build/repo/components/AppCarousel.vue').default,ProductVariants: require('/opt/build/repo/components/ProductVariants.vue').default,ProductInfos: require('/opt/build/repo/components/ProductInfos.vue').default,ProductBoutique: require('/opt/build/repo/components/ProductBoutique.vue').default,ProductExerptList: require('/opt/build/repo/components/ProductExerptList.vue').default})
